import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import EditListingNavbar from "./SellerComp/EditListingNavbar";

const PolicyCharges = () => {
  const [formData, setFormData] = useState({
    warranty: "",
    return_policy: "",
    delivery_charges: "",
    delivery_notes: "",
    delivery_km_1: "",
    delivery_charge_1: "",
    delivery_km_2: "",
    delivery_charge_2: "",
    delivery_km_3: "",
    delivery_charge_3: "",
    delivery_note_1: "",
    delivery_note_2: "",
    delivery_note_3: "",
   
    origin_pincode: "",
    delivery_time: "",
    installation_type: "",
    installation_charge: "",


  });

  const [useStandardDelivery, setUseStandardDelivery] = useState(true);
  const [useDistanceBasedDelivery, setUseDistanceBasedDelivery] = useState(false);
 
const [isFreeDelivery, setIsFreeDelivery] = useState(false);
const [origin_pincode, setOriginPincode] = useState("");


 

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { listing_id } = useParams();

  useEffect(() => {
    const fetchListingPolicies = async () => {
      try {
        const response = await axios.get(`${baseurl}getListingPolicies/${listing_id}`);
        if (response.status === 200 && response.data.success) {
          const data = response.data.data;
  
          console.log("data",data);
          // Convert distance_based_charges into flat structure
          const distanceData = {};
          (data.distance_based_charges || []).forEach((item, idx) => {
            const index = idx + 1;
            distanceData[`delivery_km_${index}`] = item.within_km;
            distanceData[`delivery_charge_${index}`] = item.charge;
            distanceData[`delivery_note_${index}`] = item.note;
          });
  
          // Set formData
          setFormData({
            warranty: data.warranty || "",
            return_policy: data.return_policy || "",
            origin_pincode: data.origin_pincode || "",
            delivery_charges: data.standard_delivery_charge || "",
            delivery_notes: data.delivery_notes || "",
            delivery_km_1: distanceData.delivery_km_1 || "",
            delivery_charge_1: distanceData.delivery_charge_1 || "",
            delivery_note_1: distanceData.delivery_note_1 || "",
            delivery_km_2: distanceData.delivery_km_2 || "",
            delivery_charge_2: distanceData.delivery_charge_2 || "",
            delivery_note_2: distanceData.delivery_note_2 || "",
            delivery_km_3: distanceData.delivery_km_3 || "",
            delivery_charge_3: distanceData.delivery_charge_3 || "",
            delivery_note_3: distanceData.delivery_note_3 || "",
            
            delivery_time: data.delivery_time || "",
            installation_type: data.installation_type || "",
            installation_charge: data.installation_charge || "",
 

          });
  
          
          // Set delivery method toggle
          setUseStandardDelivery(data.delivery_method === "standard");
          setUseDistanceBasedDelivery(data.delivery_method === "distance");
          setIsFreeDelivery(data.delivery_method === "free");
  
          // Set origin pincode
          setOriginPincode(data.origin_pincode || "");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: response.data.error || "Failed to fetch listing policies.",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "An error occurred while fetching listing policies.",
        });
      } finally {
        setLoading(false);
      }
    };
  
    if (listing_id) fetchListingPolicies();
  }, [listing_id]);
  

  // const handleInputChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Determine selected delivery method
    let origin_pincode = null;

    let delivery_method = "standard";
    if (useDistanceBasedDelivery) delivery_method = "distance";
    if (isFreeDelivery) delivery_method = "free";
  
    // Construct distance_based_charges if needed
    let distance_based_charges = [];
    if (delivery_method === "distance") {
      distance_based_charges = [1, 2, 3].map((index) => ({
        within_km: Number(formData[`delivery_km_${index}`]) || 0,
        charge: Number(formData[`delivery_charge_${index}`]) || 0,
        note: formData[`delivery_note_${index}`] || "",
      }));
      origin_pincode = formData.origin_pincode || "";

    }
  
    // Build data to send
    // const dataToSend = {
    //   listing_id,
    //   warranty: formData.warranty,
    //   return_policy: formData.return_policy,
    //   delivery_method,
    // };
    
    const dataToSend = {
      listing_id,
      warranty: formData.warranty,
      return_policy: formData.return_policy,
      delivery_time: formData.delivery_time,
      installation_type: formData.installation_type,
      installation_charge: formData.installation_charge,
      delivery_notes: formData.delivery_notes,
      delivery_method,
      standard_delivery_charge: delivery_method === "standard" ? formData.delivery_charges : null,
      distance_based_charges: delivery_method === "distance" ? distance_based_charges : [],
      origin_pincode: delivery_method === "distance" ? origin_pincode : null,
    };
    
  
    // Conditionally attach charges
    if (delivery_method === "standard") {
      dataToSend.standard_delivery_charge = Number(formData.delivery_charges) || 0;
    }
  
    if (delivery_method === "distance") {
      dataToSend.distance_based_charges = distance_based_charges;
    }
  
    // Log data being sent
    console.log("🚀 Data to be sent:", dataToSend);
  
    try {
      const response = await axios.post(`${baseurl}updateListingPolicies`, dataToSend);
      console.log("✅ API Response:", response);
  
      if (response.status === 200 && response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Updated Successfully!",
          text: response.data.message || "Listing policies updated.",
          confirmButtonText: "Ok",
        }).then(() => window.location.reload());
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed!",
          text: response.data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      console.error("❌ Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Please try again later.",
      });
    }
  };
  
  const [installOptions, setInstallOptions] = useState([]);

const fetchInstallations = async () => {
  try {
    const res = await axios.get(`${baseurl}getAllInstallations`);
    if (res.data.success) {
      setInstallOptions(res.data.data); // Only used for dropdown
    }
  } catch (error) {
    console.error("Error fetching installations:", error);
  }
};

useEffect(() => {
  fetchInstallations();
}, []);



  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2"><SellerSidebar /></div>
              <div className="col-md-10">
                <EditListingNavbar />
                <div className="reviewcls text-start">
                  <h4 className="selh1">Update Listing Policies & Charges</h4>
                  <hr />

                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <form onSubmit={handleSubmit}>


<div className="mb-3">
  <label className="form-label">Delivery Time</label>
  <input name="delivery_time"
    className="form-control"
    rows="3"
    value={formData.delivery_time || ""}
    onChange={handleInputChange}
    placeholder="Enter Delivery Time"
    /> 
    
   
</div>

<div className="mb-3">
  <label className="form-label">Installation Type</label>
  <select
    name="installation_type"
    className="form-control"
    value={formData.installation_type || ""}
    onChange={handleInputChange}
  >
    <option value="">Select Installation Type</option>
    {installOptions.map((opt, idx) => (
      <option key={idx} value={opt.name}>
        {opt.name}
      </option>
    ))}
  </select>
</div>


{formData.installation_type === "Chargable Installation" && (
  <div className="mb-3">
    <label className="form-label">Installation Charge</label>
    <input
      type="number"
      name="installation_charge"
      className="form-control"
      value={formData.installation_charge || ""}
      onChange={handleInputChange}
      placeholder="Enter Installation Charge"
    />
  </div>
)}




                      {/* Warranty & Return */}
                      <div className="mb-3">
                        <label className="form-label">Warranty</label>
                        <textarea
                          name="warranty"
                          className="form-control"
                          rows="3"
                          value={formData.warranty || ""}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Return Policy</label>
                        <textarea
                          name="return_policy"
                          className="form-control"
                          rows="3"
                          value={formData.return_policy || ""}
                          onChange={handleInputChange}
                        />
                      </div>

{/* Delivery Type Checkboxes */}
<div className="mb-3">
  <label className="form-label">Select Delivery Method</label>
  <div>
    <label className="me-4">
      <input
        type="radio"
        name="delivery_method"
        value="standard"
        checked={formData.delivery_method === "standard"}
        onChange={() => {
          setFormData((prev) => ({ ...prev, delivery_method: "standard" }));
          setUseStandardDelivery(true);
          setUseDistanceBasedDelivery(false);
          setIsFreeDelivery(false);
        }}
      />{" "}
      Standard Delivery
    </label>
    <label className="me-4">
      <input
        type="radio"
        name="delivery_method"
        value="distance"
        checked={formData.delivery_method === "distance"}
        onChange={() => {
          setFormData((prev) => ({ ...prev, delivery_method: "distance" }));
          setUseStandardDelivery(false);
          setUseDistanceBasedDelivery(true);
          setIsFreeDelivery(false);
        }}
      />{" "}
      Distance-Based Delivery
    </label>
    <label>
      <input
        type="radio"
        name="delivery_method"
        value="free"
        checked={formData.delivery_method === "free"}
        onChange={() => {
          setFormData((prev) => ({ ...prev, delivery_method: "free" }));
          setUseStandardDelivery(false);
          setUseDistanceBasedDelivery(false);
          setIsFreeDelivery(true);
        }}
      />{" "}
      Free Delivery
    </label>
  </div>
</div>




                      {/* Standard Delivery Input */}
                      {useStandardDelivery && (
                        <div className="row g-2 mb-3">
                          <div className="col-md-3">
                            <label className="form-label">Delivery Charges</label>
                            <input
                              type="number"
                              name="delivery_charges"
                              className="form-control"
                              value={formData.delivery_charges}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="col-md-9">
                            <label className="form-label">Note If Any</label>
                            <textarea
                              name="delivery_notes"
                              className="form-control"
                              rows={3}
                              value={formData.delivery_notes}
                              onChange={handleInputChange}
                            ></textarea>
                          </div>
                        </div>
                      )}

                      {/* Distance-Based Delivery Charges */}
                      {useDistanceBasedDelivery && (
                        <>


                        {/* Origin Pincode - visible only once */}
                        <div className="row g-2 mb-3">
  <div className="col-md-4">
    <label className="form-label">Origin Pincode</label>
    <input
      type="text"
      name="origin_pincode"
      className="form-control"
      value={formData.origin_pincode || ""}
      onChange={handleInputChange}
    />
  </div>
</div>




                          {[1, 2, 3].map((index) => (
                            <div className="row g-2 mb-2" key={index}>
                              <div className="col-md-3">
                                <label className="form-label">Within KM</label>
                                <input
                                  type="number"
                                  name={`delivery_km_${index}`}
                                  className="form-control"
                                  value={formData[`delivery_km_${index}`]}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col-md-3">
                                <label className="form-label">Delivery Charges</label>
                                <input
                                  type="number"
                                  name={`delivery_charge_${index}`}
                                  className="form-control"
                                  value={formData[`delivery_charge_${index}`]}
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col-md-6">
                                <label className="form-label">Note If Any</label>
                                <textarea
                                  name={`delivery_note_${index}`}
                                  className="form-control"
                                  rows={2}
                                  value={formData[`delivery_note_${index}`] || ""}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>
                          ))}
                        </>
                      )}

                      <div className="text-start">
                        <button type="submit" className="btn btn-primary">
                          Update Listing
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PolicyCharges;
